import type { DateOnly } from '@if/core/date'
import type { ETerm } from '@src/types/constants'

export enum ELoadLoansRunStatus {
  Running = 1,
  Completed = 2,
  Failed = 3,
}

export interface LoadLoansRequest {
  count: number
  activationPlannedOn: DateOnly
  firstPaymentExpectedOn: DateOnly
  term: ETerm
}

/** The LoadLoans workflow's status; the only record of a run (purged with the Durable history). */
export interface LoadLoansRun {
  status: ELoadLoansRunStatus
  requested: number
  /** Loans created so far, template included. */
  created: number
  /** Real-clock duration measured by the workflow host, immune to a simulated date. */
  elapsedSeconds: number
  errorMessage: string | null
  firstContractNumber: string | null
  lastContractNumber: string | null
}

export const isLoadLoansRunInProgress = (run: LoadLoansRun | null | undefined) =>
  run?.status === ELoadLoansRunStatus.Running
